import { zodResolver } from '@hookform/resolvers/zod';
import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  EditableLegalClientSchema,
  IEditableLegalClient,
} from '../../../../../../Interfaces/IEditLegalClient';
import {
  getEmptyLegalClient,
  ILegalClient,
} from '../../../../../../Interfaces/ILegalClient';
import { getEmptyNaturalPerson } from '../../../../../../Interfaces/INaturalPerson';
import { DialogResponsive } from '../../../../../core/DialogResponsive';
import { EditLegalClient } from '../../../../../LegalClient/EditLegalClient';
import { useLegalClientStore } from '../../../generic/legalClientStore';
import { NavRow } from '../../../generic/NavRow';

type EditLegalClientDialogProps = {
  idLegalClient: number;
  isOpen: boolean;
  onClose: () => void;
};

export const EditLegalClientDialog: React.FC<EditLegalClientDialogProps> = ({
  idLegalClient,
  isOpen,
  onClose,
}) => {
  const [putLegalClient, getLegalClient] = useLegalClientStore(state => [
    state.putLegalClient,
    state.getLegalClient,
  ]);

  const legalClientMethods = useForm<IEditableLegalClient>({
    mode: 'onChange',
    defaultValues: {
      ...getEmptyLegalClient(),
      ...getEmptyNaturalPerson(),
      idLegalClient: 1,
    },
    resolver: zodResolver(EditableLegalClientSchema),
  });

  useEffect(() => {
    if (isOpen) {
      const legalClient = getLegalClient(idLegalClient);

      if (!legalClient) {
        throw new Error(
          `LegalClient with id ${idLegalClient} not found in legalClientStore`
        );
      }

      legalClientMethods.reset({ ...legalClient } as IEditableLegalClient);
    }
  }, [isOpen, idLegalClient, getLegalClient, legalClientMethods]);

  async function onSubmit() {
    const isValid = await legalClientMethods.trigger();

    if (!isValid) {
      return;
    }

    const data = legalClientMethods.getValues();
    putLegalClient(data as ILegalClient);
    onClose();
  }

  return (
    <DialogResponsive
      open={isOpen}
      onClose={onClose}
      title='Person bearbeiten'
      maxWidth='lg'
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormProvider {...legalClientMethods}>
            <form id='testator-legal-client-form' noValidate>
              <EditLegalClient disableCompanyLegalClient />
            </form>
          </FormProvider>
        </Grid>

        <Grid item xs={12}>
          <NavRow
            nextButtonText='Speichern'
            handleNext={onSubmit}
            handleBack={onClose}
          />
        </Grid>
      </Grid>
    </DialogResponsive>
  );
};
